/* eslint-disable no-console */
import {isProdEnvironment} from '/util/env.util';
import {getErrorTrackingUtilDefaultInstance} from '/util/error-tracking/error-tracking.util';

export const recordError = (...args: any[]) => {
  if (!isProdEnvironment()) {
    console.log(...args);
    // @ts-expect-error TS(2339): Property 'tron' does not exist on type 'Console'.
    console.tron?.(...args);
  } else {
    getErrorTrackingUtilDefaultInstance().trackError(...args, 'Record Error');
  }
};
